import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "cec746e8-334e-4b66-8016-5e0efd185c8e",
    options: { imageUrl: `${config.ASSETS_URL}/03/20/task/task-2-item-1.png` },
  },
  {
    id: "1531522c-160f-4bc6-8f1a-36c80d036d4f",
    options: { imageUrl: `${config.ASSETS_URL}/03/20/task/task-2-item-2.png` },
  },
  {
    id: "0e196e65-606e-439c-bf35-849e0e2bf5b3",
    options: { imageUrl: `${config.ASSETS_URL}/03/20/task/task-2-item-3.png` },
  },
];

const groups = [
  { id: "04290c6c-314e-4120-a469-58c6c9b1e50b", content: "Over-Ear", options: {} },
  { id: "435d08ce-200e-4c3d-9a68-555590b89e25", content: "In-Ear", options: {} },
  { id: "283f9701-ead6-44a2-afec-e6d328c278ec", content: "On-Ear", options: {} },
];

export const task: Task = {
  id: "1430a8d4-2e22-4eaf-9fec-515196882d5d",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "04290c6c-314e-4120-a469-58c6c9b1e50b", itemsId: ["0e196e65-606e-439c-bf35-849e0e2bf5b3"] },
    { groupId: "435d08ce-200e-4c3d-9a68-555590b89e25", itemsId: ["1531522c-160f-4bc6-8f1a-36c80d036d4f"] },
    { groupId: "283f9701-ead6-44a2-afec-e6d328c278ec", itemsId: ["cec746e8-334e-4b66-8016-5e0efd185c8e"] },
  ],
};
